import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const setChevronPosition = (position: 'up' | 'right' | 'down' | 'left'): string => {
    if (position === 'right') {
        return 'rotate(90deg)';
    }

    if (position === 'down') {
        return 'rotate(180deg)';
    }

    if (position === 'left') {
        return 'rotate(-90deg)';
    }

    return 'rotate(0)';
};

interface SvgElementPropsType {
    position: 'up' | 'right' | 'down' | 'left';
}

const SvgElement = styled('svg', { label: 'SvgElement' })<SvgElementPropsType>`
    fill: currentcolor;
    height: auto;
    transform: ${({ position }): string => setChevronPosition(position)};
    transition: transform 0.2s ease;
`;

interface ChevronPropsType {
    className?: string;
    onClick?: (e: React.SyntheticEvent) => void;
    position: 'up' | 'right' | 'down' | 'left';
}

export const ChevronIcon = observer(
    'ChevronIcon',
    ({ className, onClick, position }: ChevronPropsType): JSX.Element => {
        return (
            <SvgElement
                className={className}
                height='24'
                onClick={onClick}
                position={position}
                viewBox='0 0 24 24'
                width='24'
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    fill='currentcolor'
                    fillRule='evenodd'
                    d='M20.788 18 22 16.706 12 6 2 16.706 3.206 18 12 8.594 20.788 18Z'
                    clipRule='evenodd'
                />
            </SvgElement>
        );
    }
);
